import { Component, OnInit, Input, Output, HostListener, EventEmitter } from '@angular/core';
import { trigger, transition, animate, style } from '@angular/animations';
import { TslDialog } from '@tesla/ng-tds';
import { I18nService } from 'app/shared/services/i18n.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'tesla-sidebar-content',
  template: `<ng-content></ng-content>`,
})
export class SidePanelDialogContentComponent { }

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'tesla-sidebar',
  templateUrl: './side-panel-dialog.component.html',
  styleUrls: ['./side-panel-dialog.component.scss'],
  animations: [
    trigger('slideIn', [
      transition('void => left', [
        style({ transform: 'translateX(-100%)' }),
        animate('350ms cubic-bezier(0, 1.07, 1, 0.97)', style({ transform: 'translateX(0)' }))
      ]),
      transition('void => right', [
        style({ transform: 'translateX(100%)' }),
        animate('350ms cubic-bezier(0, 1.07, 1, 0.97)', style({ transform: 'translateX(0)' }))
      ]),
      transition('left => void', [
        style({ transform: 'translateX(0)' }),
        animate('350ms cubic-bezier(0, 1.07, 1, 0.97)', style({ transform: 'translateX(-100%)' }))
      ]),
      transition('right => void', [
        style({ transform: 'translateX(0)' }),
        animate('350ms cubic-bezier(0, 1.07, 1, 0.97)', style({ transform: 'translateX(100%)' }))
      ]),
    ]),
  ]
})
export class SidePanelDialogComponent implements OnInit {
  @Input() title = '';
  @Input() width = '400px';
  @Input() position = 'left';

  /** Boolean flag that determines if side panel should confirm with the user before closing panel */
  @Input('confirm-close') confirmClose: boolean = false;

  /** Input title of the confimation dialog. Defaults to 'Unsaved Information' */
  @Input('confirm-title') confirmTitle: string = $localize`:@@Unsaved Information:Unsaved Information`;

  /** Input message of the confimation dialog. Defaults to generic message that warns the user of unsaved changes. */
  @Input('confirm-message') confirmMessage: string = $localize`:@@There are unsaved changes. Are you sure you want to proceed?:There are unsaved changes. Are you sure you want to proceed?`;

  @Output() onClose = new EventEmitter();

  isOpened = false;
  triggered = false;

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.isOpened) {
      this.close();
    }
  }


  constructor(private dialog: TslDialog, 
    private translate: I18nService) { }

  ngOnInit() { }

  open(): void {
    if (this.isOpened) {
      return;
    }
    this.isOpened = true;
  }

  close(surpressConfirm?: boolean): void {

    if (this.confirmClose && !surpressConfirm) {

      //  Before closing panel, ask user if it wants to proceed
      const ref = this.dialog.confirm(this.translate.get(this.confirmTitle), this.translate.get(this.confirmMessage), this.translate.get('OK'), this.translate.get('Cancel'));

      ref.afterClosed().subscribe(selection => {

        if (selection) {
          this.isOpened = false;
          this.onClose.emit();
        }
      });
    } else {

      //  Close panel without asking user
      this.isOpened = false;
      this.onClose.emit();
    }

  }
}